import EditIcon from '../../../../../assets/icons/pencil.png'
import OpenEyeIcon from '../../../../../assets/icons/open_eye.svg'
import CloseEyeIcon from '../../../../../assets/icons/close_eye.svg'
import { usePostStudy } from '../../../../../hooks/NewCase/usePostStudy'
import { useState, useEffect } from 'react'
import { useSearchPatient } from '../../../../../hooks/NewCase/useSearchPatient'
import { SessionExpired } from '../../../../SessionExpired'
import { useSearchStudyService } from '../../../../../hooks/NewCase/Service/useSearchStudyService'
import { setEvaluations } from '../../../../../redux/evaluations'
import { useUpdateUserEvaluations } from '../../../../../hooks/useUpdateUserEvaluations'
import { useDispatch, useSelector } from 'react-redux'
import { useRequiered } from '../../../../../hooks/NewCase/Requiered/useRequiered'
import { useGetStudyFromPatientId } from '../../../../../hooks/Study/useGetStudyFromPatientId'

import {
  Container,
  TitleWrapper,
  NewUserTitle,
  DniTitle,
  FillSectionWrapper,
  FillSection,
  InputWrapper,
  Label,
  InputTemplate,
  LabelContainer,
  InputFooter,
  SeparatorFillSection,
  InputWithIconWrapper,
  SmallInputWithIconWrapper,
  InputForIcon,
  IconForInput,
  SeparatorTitleSection,
  MultipleInputContainer,
  SmallInputWrapper,
  RadioGroup,
  RadioLab,
  RadioInp,
  EyeTypeAndLabelWrapper,
  EyeTypeWrapper,
  RadioEyeWrapper,
  EyeIconsWrapper,
  RadioLabel,
  RadioInput,
  ButtonsWrapper,
  Button,
  TitleContainer,
  TitleSection,
  Title,
  InputTemplateExtended,
  EyeIcon,
  SelectWrapper,
  SelectTemplate,
  Option
} from './styles'

export function PhaseTwo ({ backPhase, nextPhase }) {
  const { postStudy } = usePostStudy()
  const { patient, patientData, search } = useSearchPatient()
  const { response, searchStudy } = useSearchStudyService()
  const { isValid, setPatientData, dataError, checkRequired, buttonAvailable, errorMessages } = useRequiered('PhaseTwo')
  const [aniosDiabetes, setAniosDiabetes] = useState('')
  const [antecedentes, setAntecedentes] = useState('')
  const [altura, setAltura] = useState('')
  const [peso, setPeso] = useState('')
  const [informacionAdicional, setInformacionAdicional] = useState('')
  const { study, getStudyFromPatientId } = useGetStudyFromPatientId()

  const { user } = useSelector(state => state)
  const dispatch = useDispatch()
  const { updateUserEvaluations } = useUpdateUserEvaluations()
  const [data, setData] = useState({
    fecha: new Date(),
    paciente_id: patientData ? patientData.id : '',
    tipo: '0',
    informe: 'COMPLETAR',
    revisarProfesional: 'false',
    altura: '',
    peso: '',
    aniosConDiabetes: '',
    tieneAntecedentesGlaucoma: '',
    informacionAdicional: ''
  })

  const optAntecedentes = [
    'Si', 'No', 'No sabe'
  ]

  useEffect(() => {
    setData(prevData => ({ ...prevData, paciente_id: patientData ? patientData.id : '' }))
  }, [patientData])

  useEffect(() => {
    if (user && patientData) {
      getStudyFromPatientId(patientData.id)
    }
  }, [user, patientData])

  useEffect(() => {
    if (patientData) {
      setAntecedentes(patientData.tieneAntecedentesGlaucoma)
      setAniosDiabetes(patientData.aniosConDiabetes)
      setAltura(patientData.altura)
      setPeso(patientData.peso)
      setInformacionAdicional(patientData.informacionAdicional)
      checkRequired(patientData, false, false, false, null, patientData)
    }
  }, [patientData])

  useEffect(() => {
    setData(prevData => ({
      ...prevData,
      aniosConDiabetes: aniosDiabetes || '',
      tieneAntecedentesGlaucoma: antecedentes || '',
      altura: altura || '',
      peso: peso || '',
      informacionAdicional: informacionAdicional || ''
    }))
  }, [antecedentes, aniosDiabetes, altura, peso, informacionAdicional])

  useEffect(() => {
    search()
  }, [])

  const renderFieldError = (field) => {
    const hasError = errorMessages && typeof errorMessages === 'object' && errorMessages[field] && errorMessages[field] !== ''
    return (
      <Label
        error
        style={{ visibility: hasError ? 'visible' : 'hidden' }}
      >
        {hasError ? errorMessages[field] : 'Error'}
      </Label>
    )
  }

  useEffect(() => {
    if (response) {
      dispatch(setEvaluations(response))
      updateUserEvaluations()
      nextPhase()
    }
  }, [response])

  useEffect(() => {
    const valid = async () => {
      if (isValid) {
        const response = await postStudy(data)
        await searchStudy(response.idEstudio)
      } else {

      }
    }
    valid()
  }, [isValid])

  const changeHandler = (event) => {
    const { name, value } = event.target

    if (name === 'tieneAntecedentesGlaucoma') {
      setAntecedentes(value)
    }

    if (name === 'aniosConDiabetes') {
      setAniosDiabetes(value)
    }

    if (name === 'altura') {
      setAltura(value)
    }

    if (name === 'peso') {
      setPeso(value)
    }

    if (name === 'informacionAdicional') {
      setInformacionAdicional(value)
    }

    updateData(name, value)
  }

  const blurHandler = event => {
    const fieldName = event.target.name
    const fieldValue = event.target.value

    setData(prevData => {
      const newData = { ...prevData, [fieldName]: fieldValue }
      checkRequired(newData, false, false, false, fieldName)
      return newData
    })
  }

  const updateData = (name, value) => {
    setData(prevData => {
      const newData = { ...prevData, [name]: value }
      checkRequired(newData, false, false, false)
      return newData
    })
  }

  const saveStudy = async () => {
    checkRequired(data, false, false, true)
  }

  return (
    <Container>
      <SessionExpired />
      <TitleWrapper>
        <TitleContainer>
          <NewUserTitle> Datos de consulta </NewUserTitle>
          <DniTitle> DNI {patient && patient.dni} </DniTitle>
        </TitleContainer>
      </TitleWrapper>

      <TitleSection>
        <Title>Información adicional</Title>
        <SeparatorTitleSection />
        <Title>Datos del estudio</Title>
      </TitleSection>

      <FillSectionWrapper>
        <FillSection>
          <MultipleInputContainer>
            <SmallInputWrapper percentageWidth='45'>
              <LabelContainer>
                <Label> Años con diabetes </Label>
                <Label attenuated> (años) </Label>
              </LabelContainer>
              <SmallInputWithIconWrapper>
                <InputForIcon placeholder='Opcional' onChange={changeHandler} onBlur={blurHandler} defaultValue={data.aniosConDiabetes || ''} name='aniosConDiabetes' type='number' />
              </SmallInputWithIconWrapper>
              {renderFieldError('aniosConDiabetes')}
            </SmallInputWrapper>

            <SmallInputWrapper percentageWidth='45'>
              <LabelContainer>
                <Label>Antecedentes familiares</Label>
                <Label>de glaucoma?</Label>
              </LabelContainer>
              <SelectTemplate
                error={dataError && dataError.tieneAntecedentesGlaucoma}
                name='tieneAntecedentesGlaucoma'
                value={data.tieneAntecedentesGlaucoma || ''}
                onChange={changeHandler}
                onBlur={blurHandler}
              >
                <Option value='' disabled>Seleccionar</Option>
                {optAntecedentes.map((opt) => (
                  <Option key={opt} value={opt}>
                    {opt}
                  </Option>
                ))}
              </SelectTemplate>
              {renderFieldError('tieneAntecedentesGlaucoma')}
            </SmallInputWrapper>
          </MultipleInputContainer>

          <MultipleInputContainer>
            <SmallInputWrapper percentageWidth='45'>
              <Label>
                <Label> Altura </Label>
                <Label attenuated> (cm) </Label>
              </Label>
              <SmallInputWithIconWrapper>
                <InputForIcon placeholder='Opcional' onChange={changeHandler} onBlur={blurHandler} defaultValue={data.altura || ''} name='altura' type='number' />
              </SmallInputWithIconWrapper>
              {renderFieldError('peso') || renderFieldError('altura')}
            </SmallInputWrapper>

            <SmallInputWrapper percentageWidth='45'>
              <Label>
                <Label> Peso </Label>
                <Label attenuated> (kg) </Label>
              </Label>
              <SmallInputWithIconWrapper>
                <InputForIcon placeholder='Opcional' onChange={changeHandler} onBlur={blurHandler} defaultValue={data.peso || ''} name='peso' type='number' />
              </SmallInputWithIconWrapper>
            </SmallInputWrapper>
          </MultipleInputContainer>

          <InputWrapper extended>
            <Label>
              <Label> Información complementaria </Label>
            </Label>
            <InputTemplateExtended error={dataError && dataError.informacionAdicional} placeholder='Opcional' onChange={changeHandler} onBlur={blurHandler} defaultValue={data.informacionAdicional || ''} name='informacionAdicional' />
            {renderFieldError('informacionAdicional')}
          </InputWrapper>
        </FillSection>

        <SeparatorFillSection />
        <FillSection>
          <MultipleInputContainer>
            <SmallInputWrapper>
              <LabelContainer>
                <Label> Fecha de estudio </Label>
              </LabelContainer>
              <InputTemplate defaultValue={new Date().toISOString().split('T')[0]} onChange={changeHandler} name='fecha' type='date' />
            </SmallInputWrapper>
          </MultipleInputContainer>

          <SmallInputWrapper>
            <LabelContainer>
              <Label> Tipo de estudio </Label>
            </LabelContainer>
            <EyeTypeWrapper>
              <RadioEyeWrapper>
                <EyeIconsWrapper>
                  <EyeIcon src={OpenEyeIcon} alt='open-eye' />
                  <EyeIcon src={OpenEyeIcon} alt='open-eye' />
                </EyeIconsWrapper>
                <RadioLabel>
                  <RadioInput onChange={changeHandler} defaultChecked type='radio' name='tipo' value='0' />
                  Binocular
                </RadioLabel>
              </RadioEyeWrapper>

              <RadioEyeWrapper>
                <EyeIconsWrapper>
                  <EyeIcon src={OpenEyeIcon} alt='open-eye' />
                  <EyeIcon src={CloseEyeIcon} alt='closed-eye' />
                </EyeIconsWrapper>
                <RadioLabel>
                  <RadioInput onChange={changeHandler} type='radio' name='tipo' value='1' />
                  Monocular derecho
                </RadioLabel>
              </RadioEyeWrapper>

              <RadioEyeWrapper>
                <EyeIconsWrapper>
                  <EyeIcon src={CloseEyeIcon} alt='closed-eye' />
                  <EyeIcon src={OpenEyeIcon} alt='open-eye' />
                </EyeIconsWrapper>
                <RadioLabel>
                  <RadioInput onChange={changeHandler} type='radio' name='tipo' value='2' />
                  Monocular izquierdo
                </RadioLabel>
              </RadioEyeWrapper>
            </EyeTypeWrapper>
          </SmallInputWrapper>
        </FillSection>

      </FillSectionWrapper>

      <ButtonsWrapper>
        <Button onClick={backPhase}> Volver </Button>
        <Button highlighted disabled={!buttonAvailable} onClick={saveStudy}> Guardar </Button>
      </ButtonsWrapper>

    </Container>
  )
}

export default PhaseTwo
